// extracted by mini-css-extract-plugin
module.exports = {"card":"CardModal_card__3kVLa","content":"CardModal_content__ky3m6"};